/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 메뉴 내부의 구분자 아이템 클래스를 정의한다.
 *
 * @file /src/components/menu/elements/items/Separator.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 4. 19.
 */
import * as parent from '../Item';

export interface Listeners<T> extends parent.Listeners<T> {}

export interface Properties<T> extends parent.Properties<T> {
    /**
     * 이벤트리스너
     */
    listeners?: Listeners<T>;
}

export class Separator extends parent.Item {
    /**
     * 메뉴타입타입
     */
    variant = 'separator';

    /**
     * 메뉴 아이템에 포커스를 지정한다.
     */
    focus(): boolean {
        return false;
    }

    /**
     * 엘리먼트를 렌더링한다.
     */
    async render(): Promise<void> {
        this.$getElement().addClass('separator');

        await this.onRender();
    }
}
